<template>
    <div class="news">
        <banner title="新闻资讯" />
        <div class="aboutUs-box" v-if="web_view == 'web'">
            <div class="safe-box">
                <div class="nav-item">
                    <a :class="isNav == '1'?'nav-item-on':''" @click="nav(1)">公司简介</a>
                    <a :class="isNav == '2'?'nav-item-on':''" @click="nav(2)">发展历程</a>
                    <a :class="isNav == '3'?'nav-item-on':''" @click="nav(3)">企业文化</a>
                </div>
                <div class="aboutUs-section" v-if="isNav == '1'">
                    <div class="info">心诚养车成立于2019年6月21日，总部位于安徽芜湖，在芜湖、广州设有分公司及省级中心仓。创始人及核心团队均来自汽车后市场行业，现有员工300+人，其中市场运营团队200+人。在广东市场的同类运营公司中处于领先水平，其配件生产、查询、交易、管理、营销全数字化的产业链覆盖在中国汽后市场独树一帜，是万亿市场中的绝对种子选手！</div>
                    <div class="info">心诚养车以“让车主修车不再难、让修理厂经营不再难”为使命。致力于协同中国70万家中小规模修理厂完成服务升级，努力打造汽车配件从工厂直达修理厂的最高效供应链，让中国制造的高品质产品服务于中国汽车后市场！</div>
                    <div class="info">已经加盟心诚养车门店350+。心诚养车门店定位小而美的中小个体修理厂，此类门店整体规模小，费用低，可盈利空间大；未来规划超过一万家加盟合作门店进入心诚养车平台。</div>
                    <div class="info">心诚养车通过与上游工厂股权关系绑定，获得稳定货源工厂直销，减少中间环节，通过前置仓实现及时配送，为汽修厂提高利润空间。在大数据运用下建立完整车型配件数据库，数亿条体量数据规模实现高效智能化：一键查询、下单、支付。</div>
                    <div class="info">通过心诚养车服务体系：不仅能有效的解决修理厂日常经营管理问题，协助门店建立独特的管理体系，店端SaaS系统将修理厂服务过的每一台车及车主进行数据化汇总，汇聚成一个庞大的私域流量池，为修理厂经营提供客源。</div>
                    <img class="nav-img" src="@/assets/img/aboutUs/nav1.png" />
                </div>
                <div class="aboutUs-section" v-if="isNav == '2'">
                    <img class="nav-img2" src="@/assets/img/aboutUs/nav2.png" />
                </div>
                <div class="aboutUs-section" v-if="isNav == '3'">
                    <div v-if="!showDetail">
                        <img class="nav-img3" @click="showDetailFun('1')" src="@/assets/img/aboutUs/nav3.png" />
                        <img class="nav-img4" @click="showDetailFun('2')" src="@/assets/img/aboutUs/nav4.png" />
                        <img class="nav-img4" @click="showDetailFun('3')" src="@/assets/img/aboutUs/nav5.png" />
                    </div>
                    <div v-if="showDetail1">
                        <img class="nav-img5" src="@/assets/img/aboutUs/detail1_1.png" />
                        <div class="info">汽车后市场是一个拥有2万亿市场规模的行业，虽然发展了几十年但没有一家供应链超大型企业。几乎所有的从业者都在做着三十年来一成不变的营销模式，不论是代理，平台，连锁加盟还是自营店最终到达消费者手中的价格都是一样的，也就是说这所有的改变其实并没有改变什么实质，他们只是在服务的形式上做了一些改进，随着互联网信息高速发展，快递行业崛起，传统的分销渠道终归要慢慢的退出历史的舞台，任何行业都一定会在特定的时间窗口会出现高速发展和整合期，此时必然会有一些新的商业模式会来改变这个行业。供应链价值就在于减少流通中间环节，由源头直接供应到C端。让最具性价比产品供应给修理厂；让合作客户在同行竞争中处于绝对优势，并间接让车主获利；坚持利他商业模式，成就客户，让车主受益。心诚直销网将承载这一历史使命！</div>
                         <img class="nav-img6" src="@/assets/img/aboutUs/detail1_2.png" />
                    </div>
                    <div v-if="showDetail2">
                        <img class="nav-img5" src="@/assets/img/aboutUs/detail2_1.png" />
                        <div class="info">心诚直销网将用互联网思维作为枢纽直接把修理厂连接至厂家，把修理厂当成汽配代理商来运营的互联网+汽配公司，放弃传统的Ｂ２Ｂ模式，开启汽配领域中真正的F２B模式，让全国的修理厂。享受到没有中间商以及汽配代理商的价格。。</div>
                        <div class="info">心诚直销网是中国汽车配件市场行业的领军企业，公司由传统生产制造型集团公司转行升级为新型互联网+新零售的创业型互联网公司。商业模式的核心是将优质的汽车配件通过互联网平台的高效率以最少的流通环节送达修理厂，通过创新的供应链管理，心诚直销网的价格在同行竞争中处于绝对优势！让修理厂真正用最少钱的拿到最优质的产品，提升自身竞争力并间接让车主获益。公司秉承：客户第一、团队第二、股东第三、创业、平台、分享共赢的企业价值观，立志成为中国最大的互联网直销平台!</div>
                        <img class="nav-img6" src="@/assets/img/aboutUs/detail2_2.png" />
                    </div>
                    <div v-if="showDetail3">
                        <img class="nav-img5" src="@/assets/img/aboutUs/nav6.png" />
                        <div class="info">1. 传统的研发产品都是市场需要什么样的价格，研发团队再按照这个价格来制作产品，而心诚则是先研发质量优质的产品，再按照成本来进行定价，杜绝一切偷工减料，拒绝屈服降低品质迎合低价廉质市场！</div>
                        <div class="info">2. 心诚在行业沉淀十多年，对行业知根知底，将充分的整合上游最优质的资源直接对接至下游的终端用户，也能确保用户能够拿到一手货源，赋能终端，提升竞争力！</div>
                        <div class="info">3. 心诚直销网80%的产品由集团工厂自主生产，生产经验十多年，能够确保生产的产品都具有超高的性价比。</div>
                        <div class="info">4. 我们都知道，不是自己生产的东西，别人代工的产品，质量和价格很难达到保证，那么心诚是怎么做的呢，心诚通过合资或者收购方式参与到代工企业的管理，确保把质优价廉的产品交付于终端用户！</div>
                        <div class="info">5. 心诚所有产品出厂之前必须保证合格，出厂产品一律自检，心诚直销网管理高层也一直践行“张瑞敏”砸冰箱的理念来管理产品品质，不合格的产品绝对不允许流入市场。</div>
                        <img class="nav-img6" src="@/assets/img/aboutUs/nav7.png" />
                    </div>
                </div>
            </div>
        </div>
        <div class="aboutUs-box" v-if="web_view == 'h5'">
            <div class="safe-box-h5">
                <div class="nav-item-h5">
                    <a :class="isNav == '1'?'nav-item-on':''" @click="nav(1)">公司简介</a>
                    <a :class="isNav == '2'?'nav-item-on':''" @click="nav(2)">发展历程</a>
                    <a :class="isNav == '3'?'nav-item-on':''" @click="nav(3)">企业文化</a>
                </div>
                <div class="aboutUs-section-h5" v-if="isNav == '1'">
                    <div class="info">心诚养车成立于2019年6月21日，总部位于安徽芜湖，在芜湖、广州设有分公司及省级中心仓。创始人及核心团队均来自汽车后市场行业，现有员工300+人，其中市场运营团队200+人。在广东市场的同类运营公司中处于领先水平，其配件生产、查询、交易、管理、营销全数字化的产业链覆盖在中国汽后市场独树一帜，是万亿市场中的绝对种子选手！</div>
                    <div class="info">心诚养车以“让车主修车不再难、让修理厂经营不再难”为使命。致力于协同中国70万家中小规模修理厂完成服务升级，努力打造汽车配件从工厂直达修理厂的最高效供应链，让中国制造的高品质产品服务于中国汽车后市场！</div>
                    <div class="info">已经加盟心诚养车门店350+。心诚养车门店定位小而美的中小个体修理厂，此类门店整体规模小，费用低，可盈利空间大；未来规划超过一万家加盟合作门店进入心诚养车平台。</div>
                    <div class="info">心诚养车通过与上游工厂股权关系绑定，获得稳定货源工厂直销，减少中间环节，通过前置仓实现及时配送，为汽修厂提高利润空间。在大数据运用下建立完整车型配件数据库，数亿条体量数据规模实现高效智能化：一键查询、下单、支付。</div>
                    <div class="info">通过心诚养车服务体系：不仅能有效的解决修理厂日常经营管理问题，协助门店建立独特的管理体系，店端SaaS系统将修理厂服务过的每一台车及车主进行数据化汇总，汇聚成一个庞大的私域流量池，为修理厂经营提供客源。</div>
                    <img class="nav-img-h5" src="@/assets/img/aboutUs/nav1.png" />
                </div>
                <div class="aboutUs-section-h5" v-if="isNav == '2'">
                    <img class="nav-img2-h5" src="@/assets/img/aboutUs/nav2.png" />
                </div>
                <div class="aboutUs-section-h5" v-if="isNav == '3'">                   
                     <div v-if="!showDetail">
                        <img class="nav-img3-h5" @click="showDetailFun('1')" style="width: 97%;margin: 10px 0;margin-right: 3%;" src="@/assets/img/aboutUs/nav3.png" />
                        <img class="nav-img4-h5" @click="showDetailFun('2')" src="@/assets/img/aboutUs/nav4.png" />
                        <img class="nav-img4-h5" @click="showDetailFun('3')" src="@/assets/img/aboutUs/nav5.png" />
                    </div>
                    <div v-if="showDetail1">
                        <img class="nav-img5-h5" src="@/assets/img/aboutUs/detail1_1.png" />
                        <div class="info">汽车后市场是一个拥有2万亿市场规模的行业，虽然发展了几十年但没有一家供应链超大型企业。几乎所有的从业者都在做着三十年来一成不变的营销模式，不论是代理，平台，连锁加盟还是自营店最终到达消费者手中的价格都是一样的，也就是说这所有的改变其实并没有改变什么实质，他们只是在服务的形式上做了一些改进，随着互联网信息高速发展，快递行业崛起，传统的分销渠道终归要慢慢的退出历史的舞台，任何行业都一定会在特定的时间窗口会出现高速发展和整合期，此时必然会有一些新的商业模式会来改变这个行业。供应链价值就在于减少流通中间环节，由源头直接供应到C端。让最具性价比产品供应给修理厂；让合作客户在同行竞争中处于绝对优势，并间接让车主获利；坚持利他商业模式，成就客户，让车主受益。心诚直销网将承载这一历史使命！</div>
                        <img class="nav-img6-h5" src="@/assets/img/aboutUs/detail1_2.png" />
                    </div>
                    <div v-if="showDetail2">
                        <img class="nav-img5-h5" src="@/assets/img/aboutUs/detail2_1.png" />
                        <div class="info">心诚直销网将用互联网思维作为枢纽直接把修理厂连接至厂家，把修理厂当成汽配代理商来运营的互联网+汽配公司，放弃传统的Ｂ２Ｂ模式，开启汽配领域中真正的F２B模式，让全国的修理厂。享受到没有中间商以及汽配代理商的价格。。</div>
                        <div class="info">心诚直销网是中国汽车配件市场行业的领军企业，公司由传统生产制造型集团公司转行升级为新型互联网+新零售的创业型互联网公司。商业模式的核心是将优质的汽车配件通过互联网平台的高效率以最少的流通环节送达修理厂，通过创新的供应链管理，心诚直销网的价格在同行竞争中处于绝对优势！让修理厂真正用最少钱的拿到最优质的产品，提升自身竞争力并间接让车主获益。公司秉承：客户第一、团队第二、股东第三、创业、平台、分享共赢的企业价值观，立志成为中国最大的互联网直销平台!</div>
                        <img class="nav-img6-h5" src="@/assets/img/aboutUs/detail2_2.png" />
                    </div>
                    <div v-if="showDetail3">
                        <img class="nav-img5-h5" src="@/assets/img/aboutUs/nav6.png" />
                        <div class="info">1. 传统的研发产品都是市场需要什么样的价格，研发团队再按照这个价格来制作产品，而心诚则是先研发质量优质的产品，再按照成本来进行定价，杜绝一切偷工减料，拒绝屈服降低品质迎合低价廉质市场！</div>
                        <div class="info">2. 心诚在行业沉淀十多年，对行业知根知底，将充分的整合上游最优质的资源直接对接至下游的终端用户，也能确保用户能够拿到一手货源，赋能终端，提升竞争力！</div>
                        <div class="info">3. 心诚直销网80%的产品由集团工厂自主生产，生产经验十多年，能够确保生产的产品都具有超高的性价比。</div>
                        <div class="info">4. 我们都知道，不是自己生产的东西，别人代工的产品，质量和价格很难达到保证，那么心诚是怎么做的呢，心诚通过合资或者收购方式参与到代工企业的管理，确保把质优价廉的产品交付于终端用户！</div>
                        <div class="info">5. 心诚所有产品出厂之前必须保证合格，出厂产品一律自检，心诚直销网管理高层也一直践行“张瑞敏”砸冰箱的理念来管理产品品质，不合格的产品绝对不允许流入市场。</div>
                        <img class="nav-img6-h5" src="@/assets/img/aboutUs/nav7.png" />
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
    name: "news",
    components: {
        Banner,
    },
    data() {
        return {
            showDetail:false,
            showDetail1:false,
            showDetail2:false,
            showDetail3:false,
            web_view:"", // 视图窗口模式 900px以下是手机，以上是PC
            isNav:"1",
            loading: true,
            newsList: [],
            newstype: 1,
        };
    },
    methods: {
        showDetailFun(e){
            this.showDetail = true
            if(e == '1'){
                this.showDetail1 = true
                this.showDetail2 = false
                this.showDetail3 = false
            }else if(e == '2'){
                this.showDetail1 = false
                this.showDetail2 = true
                this.showDetail3 = false
            }else if(e == '3'){
                this.showDetail1 = false
                this.showDetail2 = false
                this.showDetail3 = true
            }
        },
        nav(e){
            if(e == '3'&&this.showDetail){
                this.showDetail = false
                this.showDetail1 = false
                this.showDetail2 = false
                this.showDetail3 = false
            }else{
                this.isNav = e
            }          
        },
    },
    mounted() {
        let that = this
        if(parseFloat(document.body.clientWidth) < 900){
            this.web_view = 'h5'
            console.log("this.web_view",this.web_view)
        }else{
            this.web_view = 'web'
            console.log("this.web_view",this.web_view)
        }
        window.addEventListener('resize', function() {// 变化后需要做的事
            if(parseFloat(document.body.clientWidth) < 900){
                this.web_view = 'h5'
                console.log("this.web_view",this.web_view)
            }else{
                this.web_view = 'web'
                console.log("this.web_view",this.web_view)
            }
            that.$forceUpdate()
        })
    },
    watch: {
        newstype(type) {
            window.console.log(type);
            this.loadData();
        },
    },
};
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
}
.news {
    width: 100%;
    height: 100%;
    background-color: #333333;
    position: relative;
    overflow: hidden;

    &-section {
        width: 100%;
        //height: 1600px;

        &-content {
            width: 1240px;
            //height: 1600px;
            margin: 0 auto;
            background-color: #fff;
            border: 1px solid red;

            .content-nav {
                width: 400px;
                height: 55px;
                margin: 0 auto;
                display: flex;
                //justify-content: center;
                align-items: center;
                position: relative;
                bottom: 30px;
                border: 1px solid red;

                &-btn {
                    width: 50%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #e4e4e4;
                    transition: all 0.2s;
                }

                .content-nav-active {
                    background-color: red;
                    color: #fff;
                }
            }

            .content-nav-item {
                width: 1070px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                //border: 1px solid blue;

                .item-list {
                    width: 330px;
                    height: 500px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    margin: 10px 10px;
                    border: 1px solid #15669e;

                    &:hover {
                        border: 1px solid #fff;
                        box-shadow: 0 0 5px 2px #bfd3e0;
                    }
                    .item-img {
                        width: 300px;
                        height: 210px;
                        background-color: #cecece;
                        background-repeat: no-repeat;
                        background-size: cover;
                        background-position: center;
                        background-origin: content-box;
                    }

                    &-title {
                        width: 300px;
                        height: 60px;
                        color: #15669e;
                        font-size: 22px;
                        padding: 0 10px;
                        margin: 20px 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        border-left: 1px solid #15669e;
                    }

                    &-content {
                        width: 273px;
                        height: 100px;
                        font-size: 14px;
                        color: gray;

                        // 文本长度处理 begin
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 5;
                        -webkit-box-orient: vertical;
                        white-space: normal !important;
                        word-wrap: break-word;
                        // 文本长度处理 ending
                    }

                    &-more {
                        width: 273px;
                        padding-top: 20px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;

                        img {
                            width: 12px;
                            height: 12px;
                        }
                        span {
                            color: #e13834;
                            padding: 0 5px;
                        }
                    }
                }
            }
        }
    }
    .text-decoration {
        text-decoration: none;
    }
}
.aboutUs-box {
    background: #333;
}
.safe-box {
    width: 1400px;
    margin: auto;
}
.nav-item {
    width:600px;
    height: 60px;
    margin: auto;
    margin-top: 40px;
    margin-bottom: 20px;
}
.nav-item a{
    width: 180px;
    box-sizing: border-box;
    padding: 12px 20px;
    border: 1px solid #fff;
    text-align: center;
    float: left;
    color: #fff;
    margin: 0 10px;
    cursor: pointer;
}

.nav-item-on {
    background: red !important;
    border: 1px solid red !important;
    color: #fff;
}
.aboutUs-section {
    width: 1200px;
    margin: auto;
    text-align: center;
}
.aboutUs-section .info {
    color: #fff;
    text-indent:32px;
    line-height: 40px;
    font-size: 18px;
    text-align: justify;
    margin-bottom: 10px;
}
.nav-img {
    width: 967px;
    margin: 40px 0;
}
.nav-img2 {
    width: 956px;
    margin: 40px 0;
}
.nav-img3 {
    cursor: pointer;
    width: 921px;
    margin: 30px 0;
}
.nav-img4 {
    cursor: pointer;
    width: 950px;
    margin: 30px 0;
    margin-left: 30px;
}
.nav-img5 {
    cursor: pointer;
    width: 1200px;
    margin: 30px 0;
}
.nav-img6 {
    margin: 40px 0;
}

.safe-box-h5 {
    width: 100%;
    margin: auto;
    padding: 10px;
    box-sizing: border-box;
}
.nav-item-h5 {
    width:100%;
    height: 36px;
    margin: auto;
}
.nav-item-h5 a{
    border: 1px solid #fff;
    width: 29%;
    box-sizing: border-box;
    padding: 6px 10px;
    text-align: center;
    float: left;
    color: #fff;
    margin: 0px 2%;
    cursor: pointer;
    font-size: 12px;
}
.aboutUs-section-h5 {
    width: 100%;
    margin: auto;
    text-align: center;
}
.aboutUs-section-h5 .info {
    color: #fff;
    text-indent: 35px;
    line-height: 28px;
    font-size: 14px;
    text-align: justify;
    margin-bottom: 10px;
}
.nav-img-h5 {
    width: 100%;
    margin: 20px 0;
}
.nav-img2-h5 {
    width: 100%;
    margin: 10px 0;
}
.nav-img3-h5 {
    cursor: pointer;
    width: 100%;
    margin: 10px 0;
}
.nav-img4-h5 {
    width: 100%;
    margin: 10px 0;
}
.nav-img5-h5 {
    width: 100%;
    margin: 10px 0;
}
.nav-img6-h5 {
    width: 100%;
    margin: 10px 0;
}
</style>
